//TODO: Find out how to fix animation without React.memo

import React from "react"
import PropTypes from "prop-types"
import clsx from "clsx"
import FeedbackAvatar from "../feedbackAvatar"
import "./card.scss"

const Card = ({ node, className }) => {
  const {
    name,
    surname,
    text,
    image
  } = node

  return (
    <section className={clsx("carousel__card", className)}>
      <header>
        <FeedbackAvatar image={image} />
        <div className="carousel__client-name">
          <h3>{name}</h3>
          <h3>{surname}</h3>
        </div>
      </header>
      <div className="text-wrapper">
        <p className="text">
          {text}
        </p>
      </div>
    </section>
  )
}

Card.propTypes = {
  node: PropTypes.shape(
    {
      name: PropTypes.string,
      surname: PropTypes.string,
      text: PropTypes.string,
      image: PropTypes.object
    }
  ).isRequired,
  className: PropTypes.string
}

Card.defaultProps = {
  className: ""
}
export default React.memo(Card)
